import { Asterisk } from "lucide-react";

const ITEMS = [
    "Custom Web Design",
    "Website Development",
    "Redesigns",
    "Responsive Design",
    "Landing Pages",
    "SEO & Performance",
    "Motion & Detail",
];

const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        aria-hidden="true"
        className="overflow-hidden border-y border-slate-200/80 bg-white py-5"
    >
        <div className="flex w-max animate-[marquee-drift_46s_linear_infinite] items-center hover:[animation-play-state:paused]">
            {[0, 1].map((copy) => (
                <div key={copy} className="flex shrink-0 items-center">
                    {ITEMS.map((item) => (
                        <span
                            key={`${copy}-${item}`}
                            className="flex items-center gap-8 pr-8 text-sm font-medium tracking-wide text-slate-400"
                        >
                            {item}
                            <Asterisk className="h-4 w-4 text-brand/60" />
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);

export default Marquee;
